/* eslint-disable no-use-before-define,jsx-a11y/role-has-required-aria-props */
import React from 'react'
import {getId} from '../twd'

export default ({
    dataName='twd-fields-checkbox-label',
    value,
    checked,
    label,
    checkboxStyle,
    showCheckbox=true,
    labelStyle,
    onChange=()=>{},
    ...props
} = {}) => {
    let id = getId()

    if (!showCheckbox) {
        return <div {...props}>{label}</div>
    }

    return <span
        className="checkbox"
        role="option"
        style={Object.assign({
            display:'inline',
            paddingTop: '1px'
        }, checkboxStyle)}>
        <input
            data-name={dataName + '-checkbox'}
            id={id}
            type="checkbox"
            value={value}
            aria-label={label}
            {...(typeof checked==='boolean' && {checked:checked, 'aria-selected':checked})}
            onChange={onChange} />
        <label htmlFor={id} style={Object.assign({
            whiteSpace: 'normal',
            verticalAlign: 'text-top',
        }, labelStyle)}>
            <div {...props}>{label}</div>
        </label>
    </span>
}
